import { useCallback, useEffect, useRef, useState } from "react";

type TFJSClassifyEventData = {
  action: "classify";
  result: [number, number];
  ts: number;
};
type TFJSClassifyEvent = MessageEvent<TFJSClassifyEventData>;

type InfoEvent = MessageEvent<{
  action: "info";
  info: {
    version: string;
    inputShape: number[];
  };
}>;

export type TFJSClassifyCallback = (data: TFJSClassifyEventData) => void;

export const useTFJSCoughDetectorWorker = (callback: TFJSClassifyCallback) => {
  const worker = useRef<Worker>();

  const [info, setInfo] = useState({
    version: "unknown",
    inputShape: [] as number[],
  });
  const [init, setInit] = useState(false);

  const initWorker = () => {
    worker.current = new Worker(`TFJS_COUGH_DETECTION_WORKER_URL`);
  };
  const stopWorker = () => {
    if (worker.current) {
      worker.current.terminate();
    }
  };

  useEffect(() => {
    initWorker();
    return stopWorker;
  }, []);

  const classify = (samples: Float32Array, ts: number) => {
    if (worker.current)
      worker.current.postMessage({
        action: "classify",
        payload: { samples, ts },
      });
  };

  const messageDispenser = useCallback(
    (ev: TFJSClassifyEvent | InfoEvent) => {
      if (ev.data.action == "classify") {
        callback(ev.data as TFJSClassifyEventData);
      } else if (ev.data.action == "info") {
        setInfo({
          version: ev.data.info.version,
          inputShape: ev.data.info.inputShape,
        });
        setInit(true);
      }
    },
    [callback]
  );

  useEffect(() => {
    if (init) {
      console.log({ info });
    }
  }, [init]);

  useEffect(() => {
    if (worker.current) worker.current.onmessage = messageDispenser;
  }, [callback]);

  return { classify, info, isInit: init };
};
